import { render, staticRenderFns } from "./UnderConstructionQuestion.vue?vue&type=template&id=3a1de7d4&scoped=true"
import script from "./UnderConstructionQuestion.vue?vue&type=script&lang=ts"
export * from "./UnderConstructionQuestion.vue?vue&type=script&lang=ts"
import style0 from "./UnderConstructionQuestion.vue?vue&type=style&index=0&id=3a1de7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1de7d4",
  null
  
)

export default component.exports